import { css, Global } from '@emotion/react'
import React, { HTMLAttributes, ReactNode } from 'react'
import { Footer } from './footer'
import { Header } from './header'
import { SEO } from './seo'
import { globalStyles } from '@/styles/global'
import resetCSS from 'emotion-reset'

export interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode
}

export function Layout({ children, ...other }: LayoutProps) {
  return (
    <div
      id="page-top"
      css={css`
        position: relative;
      `}
      {...other}
    >
      <SEO />
      <Global styles={[resetCSS, globalStyles]} />

      <Header />

      <main
        css={css`
          position: relative;
          overflow: hidden;
        `}
      >
        {children}
      </main>
      <Footer />
    </div>
  )
}
